<template>
  <div class="custom">
    <div class="fx" v-if="settlementMethodList && settlementMethodList.length > 0">
      <div class="title">结算方式</div>
      <div class="material selectBox">
        <el-radio-group v-model="dataFrom.settlementMethod" size="small" @change="getSizeRange($event, 'settlementMethod')">
          <span class="inchesFix">
            <el-radio-button v-for="item in settlementMethodList" :key="item.value" :value="item.value" :label="item.value">{{
              item.label
            }}</el-radio-button>
          </span>
        </el-radio-group>
      </div>
    </div>
    <div class="fx" v-if="formatTypes && formatTypes.length > 0">
      <div class="title">版型</div>
      <div class="material selectBox">
        <el-radio-group v-model="dataFrom.formatType" size="small" @change="getSizeRange($event, 'formatType')">
          <span class="inchesFix">
            <el-radio-button v-for="item in formatTypes" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
          </span>
        </el-radio-group>
      </div>
    </div>
    <div class="fx" v-if="lcTechnologList && lcTechnologList.length > 0">
      <div class="title">鎏彩工艺</div>
      <div class="material selectBox">
        <el-radio-group v-model="dataFrom.lcTechnology" size="small" @change="getSizeRange($event, 'lcTechnology')">
          <span class="inchesFix">
            <el-radio-button v-for="item in lcTechnologList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
          </span>
        </el-radio-group>
      </div>
    </div>
    <div class="fx" v-if="goldenWeighList && goldenWeighList.length > 0">
      <div class="title">金重</div>
      <div class="material selectBox">
        <el-radio-group v-model="dataFrom.goldWeigh" size="small" @change="getSizeRange($event, 'goldWeigh')">
          <span class="inchesFix">
            <el-radio-button v-for="item in goldenWeighList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
          </span>
        </el-radio-group>
      </div>
    </div>
    <!-- 规格 -->
    <div class="fx" v-if="handSizeList && handSizeList.length > 0">
      <div class="title">规格<span class="inchesTips" v-if="handSizeList && handSizeList[0].includes('寸')">(1英寸＝2.54厘米)</span></div>
      <div class="material selectBox">
        <el-radio-group v-model="dataFrom.ringSize" size="small" @change="getSizeRange($event, 'ringSize')">
          <span class="inchesFix">
            <el-radio-button v-for="item in handSizeList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
          </span>
        </el-radio-group>
      </div>
    </div>
    <!-- 备注 -->
    <div class="textareaRemark">
      <div class="title">备注</div>
      <el-input
        :rows="6"
        :maxlength="64"
        type="textarea"
        placeholder="其他要求与说明请在此处备注说明,字符数限制64位"
        v-model="dataFrom.productRemark"
      ></el-input>
    </div>
    <div class="box_detail_input price-wrap">
      <div
        class="price-tips"
        v-if="
          (tradePrice && (!hasPermission('展厅') || !hasPermission('加盟公司总经理') || !hasPermission('业务-数据查询'))) ||
          (labelPrice && (!dataFrom.exclusivePrice || dataFrom.exclusivePrice == 0)) ||
          (dataFrom.exclusivePrice && dataFrom.exclusivePrice != 0)
        "
      >
        (预估价格，实际价格请以结算为准)
      </div>
      <div>
        <!-- 结算金重 -->
        <div class="box_detail_input marginFx" v-if="settlementWeight && dataFrom.settlementMethod == 2">
          <div class="input-wrap">结算金重：{{ settlementWeight }}</div>
        </div>
        <!-- 结算金额-结算工费 -->
        <div
          class="box_detail_input marginFx"
          v-if="tradePrice && (!hasPermission('展厅') || !hasPermission('加盟公司总经理') || !hasPermission('业务-数据查询'))"
        >
          <div class="input-wrap">{{ dataFrom.settlementMethod == 2 ? '结算工费' : '结算金额' }}：{{ tradePrice }}</div>
        </div>
        <!-- 标签价格 -->
        <div class="box_detail_input marginFx" v-if="labelPrice && (!dataFrom.exclusivePrice || dataFrom.exclusivePrice == 0)">
          <div class="input-wrap">标签价格：{{ labelPrice }}</div>
        </div>
        <!-- 尊享价 -->
        <div class="box_detail_input marginFx" v-if="dataFrom.exclusivePrice && dataFrom.exclusivePrice != 0 && dataFrom.settlementMethod != 2">
          <div class="input-wrap">尊享价：{{ dataFrom.exclusivePrice }}</div>
        </div>
      </div>
    </div>
    <!-- 下单件数 -->
    <div class="box_detail_input marginFx">
      <div class="input-wrap">
        <span class="prompt groupColor" v-if="groupFlag != 1">起订量{{ leastQuantity }}件，可定单不同规格</span>
        <span class="prompt groupColor" v-if="groupFlag == 1">注：拼团有效期为10天，逾期则拼团失败（还差{{ dataFrom.quantityToGroup }}件成团）</span>
        <span class="prompt placeNum">购买数量：</span>
        <el-input-number
          v-model="dataFrom.quantity"
          :min="groupFlag == 1 ? 1 : leastQuantity"
          :max="9999"
          label="描述文字"
          @change="getSizeRange($event, 'quantity')"
        ></el-input-number>
      </div>
    </div>
  </div>
</template>
<script>
import { PRODUCT_CATEGOYR_NAME } from '@/utils/const';
import { getOptional, getPriceRangeSpot } from '@/api/detailsApi';
import { deepClone } from '@/utils/util';
import { Decimal } from 'decimal.js';
export default {
  name: 'Custom',
  props: {
    DataList: {
      type: Object,
      default() {
        return {};
      },
    },
    settlementMethodList: {
      type: Array,
      default() {
        return [];
      },
    },
    leastQuantity: {
      type: Number,
      default: 0,
    },
    groupFlag: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      dataFrom: {
        styleNumber: this.DataList.styleNumber, // 公司款号
        productName: this.DataList.productName,
        isCouples: this.DataList.isCouples, // 是否情侣款
        classify: 1, // 产品结构
        quantity: 0, // 数量
        shopType: 2,
        spotFlag: 2,
        ringSize: '',
        goldWeigh: '',
        lcTechnology: '',
        formatType: '',
        productRemark: '',
        tradePrice: '', //传给后端
        labelPrice: '', //传给后端
        exclusivePrice: '', //传给后端
        settlementMethod: '', //结算方式 1结价 2结料
      },
      dropDownOptional: {},
      goldenWeighList: [],
      handSizeList: [],
      lcTechnologList: [],
      formatTypes: [],
      productCategoryList: PRODUCT_CATEGOYR_NAME,
      lcTechnologyIndex: 0,
      formatTypeIndex: 0,
      tradePrice: '', //页面展示
      labelPrice: '', //页面展示
      settlementWeight: 0, //结算金重
    };
  },
  mounted() {
    this.dataFrom = { ...this.dataFrom, ...this.DataList };
    // 获取可选属性
    this.getOptional();
  },
  methods: {
    fetchPriceRange() {
      const obj = deepClone(this.dataFrom);
      // 有版型就只校验版型
      // if (this.formatTypes && this.formatTypes.length > 0) {
      //   if (!obj.formatType) return;
      // } else {
      //   // 没有版型就校验金重
      //   if (!obj.goldWeigh) return;
      // }
      if (obj.quantity == 0) obj.quantity = 1;
      getPriceRangeSpot(obj).then((res) => {
        if (obj.goldWeigh) {
          if (obj.goldWeigh?.includes('-')) {
            this.settlementWeight = new Decimal(obj.goldWeigh.split('-')[1]).mul(obj.quantity).toFixed(2);
          } else {
            this.settlementWeight = new Decimal(obj.goldWeigh).mul(obj.quantity).toFixed(2);
          }
        } else this.settlementWeight = 0;
        this.tradePrice = res.data.tradePrice;
        this.labelPrice = res.data.labelPrice;
        this.dataFrom.tradePrice = res.data.tradePrice;
        this.dataFrom.labelPrice = res.data.labelPrice;
        this.dataFrom.exclusivePrice = res.data.exclusivePrice;
      });
    },
    defaultSelected() {
      // if (this.formatTypes.length == 1) {
      //   this.dataFrom.formatType = this.formatTypes[0];
      // }
      // if (this.dropDownOptional.lcTechnologyFlag == 1) {
      //   if (this.lcTechnologList.length == 1) {
      //     this.dataFrom.lcTechnology = this.lcTechnologList[0];
      //   }
      //   if (this.goldenWeighList.length == 1) {
      //     this.dataFrom.goldWeigh = this.goldenWeighList[0];
      //   }
      //   if (this.handSizeList.length == 1) {
      //     this.dataFrom.ringSize = this.handSizeList[0];
      //   }
      // } else {
      //   if (this.goldenWeighList.length == 1) {
      //     this.dataFrom.goldWeigh = this.goldenWeighList[0];
      //   }
      //   if (this.handSizeList.length == 1) {
      //     this.dataFrom.ringSize = this.handSizeList[0];
      //   }
      // }
    },
    // 金重排序
    mainStoneSort(list) {
      // 1. 将每个区间字符串解析为对象
      const parsedRanges = list?.map((range) => {
        const [start, end] = range.split('-').map(parseFloat);
        return { start, end, range }; // 保留原始字符串以便最后恢复
      });
      // 2. 根据 start 值进行排序
      parsedRanges.sort((a, b) => a.start - b.start);
      // 3. 提取排序后的原始字符串
      return parsedRanges.map((item) => item.range);
    },
    // 获取可选属性
    getOptional() {
      let obj = {
        styleNumber: this.DataList.styleNumber,
        classify: 1,
        spotFlag: 2,
        gender: '',
        otherType: this.$route.query.codeType == 'gold18_style' ? 2 : null,
      };
      getOptional(obj).then((res) => {
        this.dropDownOptional = { ...this.dropDownOptional, ...res.data };
        this.dataFrom.settlementMethod = 2;
        this.assembleOptionalData();
        this.defaultSelected();
        this.fetchPriceRange();
      });
    },
    pickCurrentValue(list, value) {
      return list.includes(value) ? value : list[0];
    },
    assembleOptionalData() {
      const handSizeMap = this.dropDownOptional.handSizeMap || {};
      this.formatTypes = this.dropDownOptional.formatTypeFlag == 1 ? Object.keys(handSizeMap) : [];
      const currentFormatType = this.dropDownOptional.formatTypeFlag == 1 ? this.pickCurrentValue(this.formatTypes, this.dataFrom.formatType) : '';
      const currentFormatMap = this.dropDownOptional.formatTypeFlag == 1 ? handSizeMap[currentFormatType] || {} : handSizeMap;
      this.formatTypeIndex = this.formatTypes.indexOf(currentFormatType);
      if (this.dropDownOptional.lcTechnologyFlag == 1) {
        this.lcTechnologList = Object.keys(currentFormatMap);
        const currentLcTechnology = this.pickCurrentValue(this.lcTechnologList, this.dataFrom.lcTechnology);
        const currentLcTechnologyMap = currentFormatMap[currentLcTechnology] || {};
        const currentGoldWeigh = this.pickCurrentValue(this.mainStoneSort(Object.keys(currentLcTechnologyMap)), this.dataFrom.goldWeigh);
        this.lcTechnologyIndex = this.lcTechnologList.indexOf(currentLcTechnology);
        this.goldenWeighList = this.mainStoneSort(Object.keys(currentLcTechnologyMap));
        this.handSizeList = this.sortFun(
          currentGoldWeigh ? currentLcTechnologyMap[currentGoldWeigh] || [] : Object.values(currentLcTechnologyMap)[0] || [],
        );
      } else {
        const currentGoldWeigh = this.pickCurrentValue(this.mainStoneSort(Object.keys(currentFormatMap)), this.dataFrom.goldWeigh);
        this.lcTechnologList = [];
        this.lcTechnologyIndex = 0;
        this.goldenWeighList = this.mainStoneSort(Object.keys(currentFormatMap));
        this.handSizeList = this.sortFun(currentGoldWeigh ? currentFormatMap[currentGoldWeigh] || [] : Object.values(currentFormatMap)[0] || []);
      }
    },
    getSizeRange(value, type) {
      this.dataFrom[type] = value;
      if (type === 'formatType') {
        this.dataFrom.lcTechnology = '';
        this.dataFrom.goldWeigh = '';
        this.dataFrom.ringSize = '';
        this.lcTechnologyIndex = 0;
      }
      if (type === 'lcTechnology') {
        this.dataFrom.goldWeigh = '';
        this.dataFrom.ringSize = '';
      }
      if (type === 'goldWeigh') {
        this.dataFrom.ringSize = '';
      }
      if (['settlementMethod', 'formatType', 'lcTechnology', 'goldWeigh'].includes(type)) {
        this.assembleOptionalData();
        this.defaultSelected();
        this.fetchPriceRange();
        return;
      }
      this.defaultSelected();
      this.fetchPriceRange();
    },
    // 规格重新排序
    sortFun(handSizeList) {
      return handSizeList?.sort(function (a, b) {
        return a - b;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.custom {
  .fx {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    position: relative;
    margin: 8px 0;
  }

  .fl {
    display: flex;
    align-items: center;
    position: relative;
  }

  .selectBox {
    ::v-deep .el-popper {
      left: 0 !important;
    }

    .el-scrollbar__view li {
      width: 178px;
    }
  }

  .selectBoxWatch {
    .el-scrollbar__view li {
      min-width: 90px;
    }
  }
  .inchesFix {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .inchesTips {
    color: red;
    font-size: 12px;
    margin-left: 4px;
  }
  .material {
    width: 800px;
    ::v-deep .el-radio-button__inner {
      min-width: 65px;
    }
  }
  .title {
    font-size: 18px;
    color: #000;
    display: inline-block;
    margin-bottom: 8px;
    .hidden {
      visibility: hidden;
    }
  }

  .value-font {
    font-size: 18px;
    color: #ec9368;
  }
  .mainStoneClssBoxFx {
    width: 675px;
    display: flex;
    align-items: center;
    position: relative;
  }
  ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #fff;
    background-color: #ec9368;
    border-color: #ec9368;
    box-shadow: none;
  }
  ::v-deep .el-radio-button__inner:hover {
    color: rgb(236, 147, 104);
  }
  ::v-deep .el-radio-button__inner {
    margin: 5px;
    border-left: 1px solid #dcdfe6;
    border-radius: 4px;
  }
  ::v-deep .inchesFix:first-child .el-radio-button__inner {
    margin-left: 0;
  }
  ::v-deep .el-radio-group {
    display: flex;
    flex-wrap: wrap;
  }
  .input-wrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
  }
  .price-wrap {
    justify-content: flex-end;
  }
  .price-tips {
    color: red;
    margin-right: 10px;
  }
}
</style>
